<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">应用市场</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">仪表盘</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="report-content">
            <div class="left-data">
                <a-card title="销售简报" style="width: 100%">
                    <a slot="extra" href="#">
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="xstime" @click="xsshowdate">
                                <a-tooltip slot="suffix" @click="xsshowdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="xsdateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdatexs(i,item)" :class="{clickdate:i==xscurrentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChangexs"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a>
                    <ul class="data">
                        <li>
                            <span class="img"><img src="../../../static/svg/user.svg" alt=""></span>
                            <span class="text">新增客户</span>
                            <span class="data">{{saledata.newkehu}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/user.svg" alt=""></span>
                            <span class="text">新增联系人</span>
                            <span class="data">{{saledata.newcontract}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/clue.png" alt=""></span>
                            <span class="text">新增线索</span>
                            <span class="data">{{saledata.newdata}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/business.png" alt=""></span>
                            <span class="text">新增商机</span>
                            <span class="data">{{saledata.newbussness}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/num.svg" alt=""></span>
                            <span class="text">赢单数量</span>
                            <span class="data">{{saledata.win}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/conver.png" alt=""></span>
                            <span class="text">已转化线索</span>
                            <span class="data">{{saledata.conversionnum}}</span>
                        </li>
                    </ul>
                </a-card>

                <!-- <a-card title="名片简报" style="width: 100%;margin-top:10px">
                    <a slot="extra" href="#">more</a>
                    <ul>
                        <li>
                            <span class="img"><img src="../../../static/svg/eye.png" alt=""></span>
                            <span class="text">浏览次数</span>
                            <span class="data">3</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/user.svg" alt=""></span>
                            <span class="text">新增访客人数</span>
                            <span class="data">3</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/consult.png" alt=""></span>
                            <span class="text">咨询人数</span>
                            <span class="data">3</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/phone.png" alt=""></span>
                            <span class="text">授权手机号人数</span>
                            <span class="data">3</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/forward.png" alt=""></span>
                            <span class="text">转发次数</span>
                            <span class="data">3</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/conver.png" alt=""></span>
                            <span class="text">已转线索人数</span>
                            <span class="data">3</span>
                        </li>
                    </ul>
                </a-card> -->

                <a-card title="跟进统计" style="width: 100%;margin-top:10px">
                    <a slot="extra" class="tjselect" href="#">
                       
                        <a-select maxTagCount="0"  mode="multiple" placeholder="选择员工" v-model="belong" style="width: 120px" @change="handleChangeyg">
                            <!-- <a-icon slot="suffixIcon" type="user-add" /> -->
                            <a-select-option v-for="item in userlist" :value="item.id" :key="item.id">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="time" @click="showdate">
                                <a-tooltip slot="suffix" @click="showdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdate(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChange"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a>
                    <ul class="data">
                        <li>
                            <span class="img"><img src="../../../static/svg/eye.png" alt=""></span>
                            <span class="text">写跟进次数</span>
                            <span class="data">{{gjstatic.follownum}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/user.svg" alt=""></span>
                            <span class="text">打电话次数</span>
                            <span class="data">{{gjstatic.callnum}}</span>
                        </li>

                        <li>
                            <span class="img"><img src="../../../static/svg/phone.png" alt=""></span>
                            <span class="text">跟进线索次数</span>
                            <span class="data">{{gjstatic.datanum}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/forward.png" alt=""></span>
                            <span class="text">跟进客户次数</span>
                            <span class="data">{{gjstatic.kehunum}}</span>
                        </li>
                        <li>
                            <span class="img"><img src="../../../static/svg/conver.png" alt=""></span>
                            <span class="text">跟进商机次数</span>
                            <span class="data">{{gjstatic.bussnessnum}}</span>
                        </li>
                        <li>
                            <!-- <span class="img"><img src="../../../static/svg/consult.png" alt=""></span>
                            <span class="text">签到次数</span>
                            <span class="data">3</span> -->
                        </li>
                    </ul>
                </a-card>

                <a-card title="排行榜(TOP 3)" style="width: 100%;margin-top:10px">
                    <a slot="extra" href="#">
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="phbtime" @click="phbshowdate">
                                <a-tooltip slot="suffix" @click="phbshowdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="phbdateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdatephb(i,item)" :class="{clickdate:i==phbcurrentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChangephb"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a>
                    <a-table :columns="columns" :data-source="data" :pagination="page">
                        <a slot="name" slot-scope="text">{{ text }}</a>
                    </a-table>
                </a-card>
            </div>

            <div class="right-chart">
                <a-card title="销售漏斗" style="width: 100%;">
                    <a slot="extra" href="#">
                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="ldtime" @click="ldshowdate">
                                <a-tooltip slot="suffix" @click="ldshowdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="lddateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdateld(i,item)" :class="{clickdate:i==ldcurrentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChangeld"/>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </a>
                    <div id="weightChart" style="width: 100%;height:394px;"></div>
                </a-card>
                <!-- <a-card title="目标" style="width: 100%;">
                    <a slot="extra" href="#">more</a>
                    <div id="weightChart" style="width: 100%;height:300px;"></div>
                </a-card> -->

                <a-card title="销售对比" style="width: 100%;margin-top:10px">
                    <a slot="extra" href="#">

                        <div class="select-date-custom">
                            <a-input class="search-date" v-model="dbtime" @click="dbshowdate">
                                <a-tooltip slot="suffix" @click="dbshowdate">
                                    <div class="date-icon"></div>
                                </a-tooltip>
                            </a-input>
                            <span class="select-date-modal" v-if="dbdateshow">
                                <div class="date-modal">
                                    <div class="time-modal">
                                        <div class="time-system">
                                            <div class="select-item" @click="selectdatedb(i,item)" :class="{clickdate:i==dbcurrentdate}" v-for="(item,i) in datelist" :key="i">{{item}}</div>
                                        </div>
                                        <div class="time-custom">
                                            <span class="time-system-text">自定义</span>
                                            <div class="time-select-index-hide">
                                                <a-range-picker format="YYYY-MM-DD" @change="dateChangedb"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>

                    </a>
                    <div id="xsChart" style="width: 100%;height:400px;"></div>
                </a-card>
            </div>
        </div>
    </div>
</template>

<script>
const columns = [
  {
    title: '排名',
    dataIndex: 'rank',
    key: 'rank',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '人员名字',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '赢单数量',
    dataIndex: 'winnum',
    key: 'winnum',
    ellipsis: true,
  },
  {
    title: '我的差距',
    dataIndex: 'gap',
    key: 'gap',
    ellipsis: true,
  }
];

export default {
    data(){
        return{
            data:"",
            columns,
            page:false,
            gjstatic:"",
            saledata:"",
            lddata:"",
            saleline:"",


            time:"今天",
            dateshow:false,
            currentdate:"",
            datelist:['今天','昨天','本周','上周','本月','上月'],
            belong:[],
            userlist:"",

            xstime:"今天",
            xsdateshow:false,
            xscurrentdate:"",

            phbtime:"今天",
            phbdateshow:false,
            phbcurrentdate:"",

            dbtime:"今天",
            dbdateshow:false,
            dbcurrentdate:"",

            ldtime:"今天",
            lddateshow:false,
            ldcurrentdate:"",
        }
    },
    mounted(){

        this.ldtj()
        this.dbtj()
        this.gjtj()
        this.xstj()
        this.phbtj()

        //  员工列表
        this.$axios.get('/api/userlist',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }  
         }).then((res)=>{
             if(res.data.code==200){
                this.userlist=res.data.data.lists
             }else{
                this.$message.error(res.data.msg);
             }
         })

    },
    methods:{
        showdate(){
            this.dateshow=!this.dateshow
        },
        xsshowdate(){
            this.xsdateshow=!this.xsdateshow
        },
        phbshowdate(){
            this.phbdateshow=!this.phbdateshow
        },
        dbshowdate(){
            this.dbdateshow=!this.dbdateshow
        },
        ldshowdate(){
            this.lddateshow=!this.lddateshow
        },
        // 员工筛选
        handleChangeyg(value){
            this.belong=value
            this.gjtj()
        },
        // 跟进日期筛选
        selectdate(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.gjtj()
        },
        dateChange(data,dateString){
            console.log(dateString)
            this.time=dateString[0]+'~'+dateString[1]
            this.dateshow=false
            this.gjtj()
        },
        // 销售日期筛选
        selectdatexs(a,b){
            this.xscurrentdate=a
            this.xstime=b
            this.xsdateshow=false
            this.xstj()
        },
        dateChangexs(data,dateString){
            this.xstime=dateString[0]+'~'+dateString[1]
            this.xsdateshow=false
            this.xstj()
        },

        // 排行榜日期筛选
        selectdatephb(a,b){
            this.phbcurrentdate=a
            this.phbtime=b
            this.phbdateshow=false
            this.phbtj()
        },
        dateChangephb(data,dateString){
            this.phbtime=dateString[0]+'~'+dateString[1]
            this.phbdateshow=false
            this.phbtj()
        },

        // 销售对比日期筛选
        selectdatedb(a,b){
            this.dbcurrentdate=a
            this.dbtime=b
            this.dbdateshow=false
            this.dbtj()
        },
        dateChangedb(data,dateString){
            this.dbtime=dateString[0]+'~'+dateString[1]
            this.dbdateshow=false
            this.dbtj()
        },

        // 销售漏斗日期筛选
        selectdateld(a,b){
            this.ldcurrentdate=a
            this.ldtime=b
            this.lddateshow=false
            this.ldtj()
        },
        dateChangeld(data,dateString){
            console.log(dateString)
            this.ldtime=dateString[0]+'~'+dateString[1]
            this.lddateshow=false
            this.ldtj()
        },

        ldtj(){
            // 销售漏斗
            this.$axios.get('/api/salefunnel',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.ldtime
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.lddata=res.data.data
                    this.drawLine()
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },

        dbtj(){
             //  销售对比

        this.$axios.get('/api/salecontrast',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.dbtime
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.saleline=res.data.data
                    this.drawLine2()
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },

        phbtj(){
              // 排行榜
            this.$axios.get('/api/toprank',{
                headers:{
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.phbtime
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.data=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        xstj(){
            // 销售简报
            this.$axios.get('/api/singlesale',{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    date:this.xstime
                }
  
            }).then((res)=>{
                if(res.data.code==200){
                    this.saledata=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        gjtj(){
            //  跟进统计
            this.$axios.post('/api/followstatictis',{
                date:this.time,
                belong:this.belong
            },{
                headers:{
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjstatic=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        drawLine2(){
            var xsChart = this.$echarts.init(document.getElementById("xsChart"))
            xsChart.setOption({
                xAxis: {
                    type: 'category',
                    data:this.saleline.xaixs,
                    boundaryGap: false,
                   
                },
                yAxis: {
                    name: '呼出/接听次数',
                    type: 'value',
                    position:'right'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#fff',
                            color: '#333'
                        },
                    }
                },
                grid: {  
                    left: '5%',  
                    right: '4%', 
                    top:'10%', 
                    bottom: '14%',  
                    containLabel: true  
                },  
                series: [{
                    data: this.saleline.yaixs,
                    type: 'line',
                    smooth: true,
                    itemStyle: {
                        normal: {
                            color: '#bd48f9', //改变折线点的颜色
                            lineStyle: {
                                color: '#bd48f9' //改变折线颜色
                            }
                        }
                    },
     
                }]
            });
        },

        drawLine(){
            var weightChart = this.$echarts.init(document.getElementById("weightChart"))
            weightChart.setOption({
                color: ['#6688f9','#6688f9','#6688f9','#6688f9','#5fcaca','#c6cde5' ],

                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c}%"
                },
    
                series: [ 
                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '10%',
                        maxSize: '90%',
                        sort: 'descending',
                        gap: 2,
                       
                        emphasis: {
                            label: {
                                fontSize: 14,
                            }
                        },
                        data: [
                            {value: 90, name: '初步接洽',barHeight: 6},
                            {value: 75, name: '需求确定'},
                            {value: 60, name: '方案/报价'},
                            {value: 45, name: '谈判审核'},
                            {value: 30, name: '赢单'},
                            {value: 15, name: '输单'},
                        ]
                    },

                    {
                        name:'漏斗图',
                        type:'funnel',
                        left: '5%',
                        top: 60,
                        bottom: 60,
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '10%',
                        maxSize: '90%',
                        label: {
                            position: 'inside',
                            formatter: '￥{b}',
                            color: '#fff'
                        },
                        itemStyle: {
                            opacity: 0.5,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        emphasis: {
                            label: {
                               formatter: '￥{b}' 
                            }
                        },
                        data: [

                            {value: 90, name: this.lddata.first,barHeight: 6},
                            {value: 75, name: this.lddata.needs},
                            {value: 60, name: this.lddata.plans},
                            {value: 45, name: this.lddata.negotiate},
                            {value: 30, name: this.lddata.win},
                            {value: 15, name: this.lddata.lose},
                        ],
                        // Ensure outer shape will not be over inner shape when hover.
                        z: 100
                    }
                ]
            });
            // weightChart.setOption({
            //     tooltip: {
            //         trigger: 'item',
            //         formatter: "{a} <br/>{b} : {c}%"
            //     },
            //     grid: {  
            //         top:'6%', 
            //         bottom: '14%',  
            //         containLabel: true  
            //     }, 
            //     series: [
            //         {
            //             name:'漏斗图',
            //             type:'funnel',
            //             left: '5%',
            //             top: 30,
            //             bottom: 40,
            //             width: '80%',
            //             min: 0,
            //             max: 100,
            //             minSize: '12%',
            //             maxSize: '100%',
            //             sort: 'descending',
            //             gap: 2,
                       
            //             emphasis: {
            //                 label: {
            //                     fontSize: 14
            //                 }
            //             },
            //             data: [
            //                 {value: 90, name: '初步接洽',barHeight: 6},
            //                 {value: 75, name: '需求确定'},
            //                 {value: 60, name: '方案/报价'},
            //                 {value: 45, name: '谈判审核'},
            //                 {value: 30, name: '赢单'},
            //                 {value: 15, name: '输单'},
            //             ]
            //         }
            //     ]
            // });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/data/report.vue